import { GatsbyImage } from "gatsby-plugin-image"
import React from "react"
import { mobileImage, desktopImage, image } from "./inline-image.module.css"
import { Link } from "gatsby"
import linkBuilder from "../../modules/linkBuilder"

import { trackEvent } from "../../modules/analytics"
import { eventTracking } from "../../services/tracking"

const InlineImageContent = ({ data }) => {
  return (
    <>
      <div className={desktopImage}>
        {data.image.mimeType === "image/svg+xml" ? (
          <img className={image} src={data.image.file.url} />
        ) : (
          <GatsbyImage
            image={data.image.gatsbyImageData}
            className={image}
            alt={data.title}
          />
        )}
      </div>
      <div className={mobileImage}>
        {data.imageMobile?.mimeType === "image/svg+xml" ? (
          <img
            className={image}
            src={
              data.imageMobile?.file
                ? data.imageMobile?.file.url
                : data.image.file.url
            }
          />
        ) : (
          <GatsbyImage
            image={
              data.imageMobile?.gatsbyImageData
                ? data.imageMobile.gatsbyImageData
                : data.image.gatsbyImageData
            }
            className={image}
            alt={data.title}
          />
        )}
      </div>
    </>
  )
}

const InlineImage = ({ data, parentData }) => {
  const linkRef = data.linkReference
  let internalLink, externalLink

  switch (linkRef?.__typename) {
    case "ContentfulArticle":
      internalLink = linkBuilder.article(data.linkReference)
      break
    case "ContentfulDesk":
      internalLink = linkBuilder.desk(data.linkReference)
      break
    case "ContentfulDeskCategory":
      internalLink = linkBuilder.deskCategory(data.linkReference)
      break
    case "ContentfulDownload":
      internalLink = linkBuilder.download(data.linkReference)
      break
    case "ContentfulCampaign":
      internalLink = linkBuilder.campaign(data.linkReference)
      break
    case "ContentfulProductBeta":
      internalLink = linkBuilder.product(data.linkReference)
      break
    case "ContentfulPage":
      internalLink = linkBuilder.page(data.linkReference)
      break
    case "ContentfulExternalLink":
      externalLink = data?.linkReference?.url
      break
    default:
      break
  }

  if (internalLink) {
    return (
      <Link
        to={internalLink}
        title={data.title}
        onClick={() => trackEvent("cta_inline_image")}
      >
        <InlineImageContent data={data} />
      </Link>
    )
  } else if (externalLink) {
    return (
      <a
        href={externalLink}
        title={data.title}
        onClick={() => {
          trackEvent("cta_inline_image")
          eventTracking("click", {
            contentfulId: data.contentful_id,
            contentfulType: "inlineImage",
            contentfulTitle: data.title,
            displayPageContentfulId: parentData?.pageContentfulId,
            displayPageContentfulTitle: parentData?.pageContentfulTitle,
            displayPosition: parentData?.position,
          })
        }}
        rel={
          data?.linkReference?.sponsored
            ? "sponsored noreferrer noopener nofollow"
            : "noreferrer noopener"
        }
        target="_blank"
      >
        <InlineImageContent data={data} />
      </a>
    )
  } else {
    return <InlineImageContent data={data} />
  }
}

export default InlineImage
